let drinkPlan = [
  {
    type: '上午',
    data: [
      {
        time: '7:00 - 8:00',
        cup: 1
      },
      {
        time: '9:00 - 10:00',
        cup: 1
      },
      {
        time: '11:00 - 11:30',
        cup: 1
      }
    ]
  },
  {
    type: '下午',
    data: [
      {
        time: '13:00 - 13:30',
        cup: 1
      },
      {
        time: '14:30 - 15:30',
        cup: 1
      },
      {
        time: '16:00 - 17:30',
        cup: 1
      }
    ]
  },
  {
    type: '晚上',
    data: [
      {
        time: '18:00 - 19:00',
        cup: 1
      },
      {
        time: '20:00 - 21:00',
        cup: 1
      }
    ]
  }
]
let coachAvatarList = [
  {
    url: 'https://cdnvue.gymcity.com.cn/uploads/c6f912a387e73feebfb08ea11affaef5.jpg',
    name: '盖盖',
    card: [
      '国家公共营养师',
      '国家健康管理师',
      '慢性病康复适宜技术全国专家委员会委员',
      '深耕营养健康领域6年',
      '慢病调控与饮食减肥！',
      '曾任职于国际知名瘦身及代谢综合征健康管理公司加拿大IdealProtein大中华区健康管理部首席健康教练'
    ]
  },
  {
    url: 'https://cdnvue.gymcity.com.cn/uploads/69f3a62eea28ee7ba6cdc5323d12c4d3.jpg',
    name: '玲玲',
    card: [
      '毕业于湖南中医药大学',
      '国家公共营养师',
      '深耕大健康行业6年，有丰富减脂实战工作经验，帮助5000+学员快乐瘦身，养成科学饮食习惯，成为身材和食物的主人！',
      '擅长通过营养膳食指导，心理疏导，帮助学员收获瘦身梦想的同时，重拾健康!'
    ]
  },
  {
    url: 'https://cdnvue.gymcity.com.cn/uploads/870fc309ec6d520772f067458b8b4013.jpg',
    name: '山山',
    card: [
      '毕业于中医药大学药学专业',
      '国家公共营养师',
      '当红不让中级营养师',
      '体重管理师',
      '3年健康管理经验，帮助5000+人科学健康减脂成功！'
    ]
  },
  {
    url: 'https://cdnvue.gymcity.com.cn/uploads/feeeef14ad0a82e14f07e2a61e455640.jpg',
    name: '夏夏',
    card: [
      '注册营养技师（DTR）',
      '营养配餐专业',
      '专注于食物搭配与身体营养需求的关系'
    ]
  },
  {
    url: 'https://cdnvue.gymcity.com.cn/uploads/375f0f2548cb224e2829b5a7b3f280d6.jpg',
    name: '阳阳',
    card: [
      '注册营养技师',
      '中国营养学会会员',
      '运动营养师',
      '从事大健康行业四年，丰富的体重管理经验，擅长通过饮食指导，定制学员个性化减脂方案，帮助学员养成“易瘦体质”生活习惯！'
    ]
  },
  {
    url: 'https://cdnvue.gymcity.com.cn/uploads/352c669055cd6dc65d555e011c202ea7.jpg',
    name: '又又',
    card: [
      '国家健康管理师',
      '亚洲瑜伽协会高级教练',
      '对于攻克减脂平台期有着丰富的经验！',
      '善于缓解客户减脂过程中焦虑情绪，提倡快乐减脂！',
      '21天帮助会员最高减重15斤以上，轻松健康养成易瘦体质~'
    ]
  }
]
export { drinkPlan, coachAvatarList }
